import React, { useState } from 'react';
import styles from './styles.module.scss';
import { ConsentState } from '../../types';

interface PartnerConsentSlideProps {
  consent: ConsentState;
  onConsentChange: (consent: ConsentState) => void;
  onContinue: () => void;
  onContinueWithoutAccepting: () => void;
}

type PartnerConsentKey = 'thirdPartyMarketing' | 'thirdPartyProfiling';

const CONSENT_ITEMS: Array<{
  key: PartnerConsentKey;
  title: string;
  description: React.ReactNode;
}> = [
  {
    key: 'thirdPartyMarketing',
    title: 'Comunicazione dei dati a società partner',
    description: (
      <>
        Acconsento alla comunicazione dei miei dati alle società partner indicate{' '}
        <a
          className={styles.partnerLink}
          href="https://www.enpal.com/it/protezione-dei-dati"
          target="_blank"
          rel="noopener noreferrer"
        >
          nell&apos;elenco
        </a>
        , nei settori: energia e utilities, servizi finanziari, edilizia e
        ristrutturazioni, per l&apos;invio di comunicazioni promozionali.
      </>
    ),
  },
  {
    key: 'thirdPartyProfiling',
    title: 'Profilazione per proposte su misura',
    description:
      'Acconsento alla profilazione e all’analisi delle mie preferenze da parte di Enpal e/o partner terzi, per ricevere proposte su misura.',
  },
];

/**
 * Slide consensi partner — tra telefono e thank you
 */
const PartnerConsentSlide: React.FC<PartnerConsentSlideProps> = ({
  consent,
  onConsentChange,
  onContinue,
  onContinueWithoutAccepting,
}) => {
  // Lo stato del consenso è booleano: qui serve distinguere anche "non risposto"
  const [answers, setAnswers] = useState<Record<PartnerConsentKey, boolean | null>>({
    thirdPartyMarketing: null,
    thirdPartyProfiling: null,
  });

  const handleChange = (field: PartnerConsentKey, value: boolean) => {
    setAnswers((prev) => ({ ...prev, [field]: value }));
    onConsentChange({ ...consent, [field]: value });
  };

  return (
    <div className={styles.partnerConsentSlide}>
      <h3 className={styles.title}>
        Per ricercare ulteriori bonus disponibili potremmo doverci rivolgere a
        nostri partner
      </h3>

      <div className={styles.consentCard}>
        {CONSENT_ITEMS.map((item) => (
          <div key={item.key} className={styles.question}>
            <h5 className={styles.questionTitle}>{item.title}</h5>
            <p className={styles.questionDescription}>{item.description}</p>

            <div className={styles.choiceRow}>
              <button
                type="button"
                className={`${styles.choiceBtn} ${
                  answers[item.key] === true ? styles.selected : ''
                }`}
                onClick={() => handleChange(item.key, true)}
                aria-pressed={answers[item.key] === true}
              >
                <span className={styles.radioDot} />
                Sì, acconsento
              </button>
              <button
                type="button"
                className={`${styles.choiceBtn} ${
                  answers[item.key] === false ? styles.selected : ''
                }`}
                onClick={() => handleChange(item.key, false)}
                aria-pressed={answers[item.key] === false}
              >
                <span className={styles.radioDot} />
                No, grazie
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.buttonGroup}>
        <button
          type="button"
          className={styles.btnSecondary}
          onClick={onContinueWithoutAccepting}
        >
          Prosegui senza accettare
        </button>
        <button type="button" className={styles.btnPrimary} onClick={onContinue}>
          Prosegui
        </button>
      </div>
    </div>
  );
};

export default PartnerConsentSlide;
